import { useState, useEffect } from 'react'
import { calculateGestationalAge } from '../utils/dueDateCalculator'
import { formatDate } from '../utils/locale'
import './DueDateDisplay.css'

interface DueDateDisplayProps {
  lmpDate: string
  eddDate: string
}

export function DueDateDisplay({ lmpDate, eddDate }: DueDateDisplayProps) {
  const [daysRemaining, setDaysRemaining] = useState<number | null>(null)

  useEffect(() => {
    const today = new Date()
    const edd = new Date(eddDate)
    const diffMs = edd.getTime() - today.getTime()
    const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24))
    setDaysRemaining(diffDays)
  }, [eddDate])

  const gestationalAge = calculateGestationalAge(lmpDate)

  return (
    <div className="due-date-display">
      <div className="edd-primary">{formatDate(eddDate)}</div>
      {daysRemaining !== null && (
        <div className={`edd-countdown ${daysRemaining < 0 ? 'overdue' : daysRemaining <= 14 ? 'soon' : ''}`}>
          {daysRemaining < 0
            ? `${Math.abs(daysRemaining)} days overdue`
            : daysRemaining === 0
              ? 'Due today'
              : daysRemaining === 1
                ? 'Due tomorrow'
                : `${daysRemaining} days remaining`}
        </div>
      )}
      <div className="edd-gestational-age">Current: {gestationalAge.display}</div>
    </div>
  )
}
